import { useContext } from "react";
import logo from "../public/demo/images/logo/logo.svg";
import logoAlt from "../public/demo/images/logo/logo_alt.png";
import AppMenu from "./AppMenu";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";

const AppSidebar = () => {
  const { setLayoutState } = useContext(LayoutContext);
  const anchor = () => {
    setLayoutState((prevLayoutState) => ({
      ...prevLayoutState,
      anchored: !prevLayoutState.anchored,
    }));
  };
  return (
    <>
      <div className="sidebar-header">
        <a href="/" className="app-logo">
          <img
            src={logo}
            alt="apollo-layout"
            style={{
              width: "120px",
              height: "auto",
              margin: "auto 0",
              filter: "invert(1)",
            }}
            className="app-logo-normal mt-1"
          />
          <img
            src={logoAlt}
            alt="apollo-layout"
            style={{ width: "22px", filter: "invert(1)" }}
            className="app-logo-small"
          />
        </a>
        <button
          className="layout-sidebar-anchor p-link z-2"
          type="button"
          onClick={anchor}
        ></button>
      </div>

      <div className="layout-menu-container">
        <MenuProvider>
          <AppMenu />
        </MenuProvider>
      </div>
    </>
  );
};

export default AppSidebar;
